import React from 'react';
import { KIND_LABEL, formatNumber, formatPercent } from './format';
import { Headline, MeasureRow, ScoreCard, TrendLine, versionRange } from './ScoreParts';

const KIND_PLURAL = { feature: 'feature releases', maintenance: 'maintenance releases', hotfix: 'hotfixes' };

const tip = (p) => ({
  title: p.version,
  kind: KIND_LABEL[p.kind],
  lines: [`${formatPercent(p.passRate)} passed`, `${formatNumber(p.total)} tests planned · select to open`]
});

const Scorecard = ({ scorecard, onSelect }) => {
  if (!scorecard || !scorecard.latest) return null;
  const { latest, baseline, measures, trend } = scorecard;
  const passRate = measures.find((m) => m.key === 'passRate');
  const since = baseline && `since the first ${baseline.versions.length > 1 ? `${baseline.versions.length} ` : ''}${KIND_PLURAL[baseline.kind]} (${versionRange(baseline.versions)}), which averaged ${formatPercent(passRate.earlier)}.`;
  return (
    <ScoreCard
      headline={<Headline caption={`Latest ${KIND_LABEL[latest.kind].toLowerCase()} release · ${latest.version}`} value={formatPercent(passRate.value)} label="of planned tests passed" measure={passRate} since={since} />}
      chart={<TrendLine title="Pass rate, release by release" legend="Filled dot: maintenance or hotfix · ring: feature release" data={trend} valueKey="passRate" unit="rate" tip={tip} onSelect={onSelect} />}
    >
      <MeasureRow measures={measures} baselineLabel={baseline && `average of ${versionRange(baseline.versions)}`} />
    </ScoreCard>
  );
};

export default Scorecard;
